import { render, staticRenderFns } from "./MspAnnuncioUi.vue?vue&type=template&id=0d73b89c&scoped=true"
import script from "./MspAnnuncioUi.vue?vue&type=script&lang=js"
export * from "./MspAnnuncioUi.vue?vue&type=script&lang=js"
import style0 from "./MspAnnuncioUi.vue?vue&type=style&index=0&id=0d73b89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d73b89c",
  null
  
)

export default component.exports